import { CompanysitesService } from '../../../admin-dashboard/company-sites/company-sites.service';
import { Component, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Params, ActivatedRoute } from '@angular/router';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Subject, combineLatest, zip, Subscription } from 'rxjs';
import { switchMap, reduce, map } from 'rxjs/operators';
import { ReportGeneratorService } from '../../../admin-dashboard/report-generator/report-generator.service';
import { SalesReportService } from '../../../services/sales-report.service';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { ExcelService } from 'src/app/shared/excel';
@Component({
  selector: 'app-sale-report-generator-result',
  templateUrl: './sale-report-generator-result.component.html',
  styleUrls: ['./sale-report-generator-result.component.css']
})
export class SaleReportGeneratorResultComponent implements OnInit, OnDestroy {
  @ViewChild('table', { static: false }) table: ElementRef;
  dataSource$: Observable<MatTableDataSource<any>>;
  filter$: Subject<string>;
  dataSource;
  // displayedColumns: string[] = ['systemName', 'productNumber', 'productName', 'qty', 'price'];
  // columnSettings: ColumnSetting[]
  columnSettings;
  columnTotals: { [key: string]: number } = {};
  exportData = [];

  siteName: string;
  systemName: string;
  employee: string;
  product: string;
  dateFrom: string;
  dateTo: string;
  forceLoading: boolean = true;
  forceLoading$: Observable<boolean>;
  values$: Observable<any>;
  siteData$: Observable<any>;
  siteDataSub: Subscription;
  sortingArray = []
  displayedColumns: string[] = ['companyId', 'systemName', 'productName', 'qty', 'price', 'priceWithoutMVA', 'discountedPrice'] // Add other column names here

  constructor(public excelService: ExcelService,private saleService: SalesReportService, private route: ActivatedRoute, private siteService: CompanysitesService) {



    this.columnSettings = [
      {
        columnId: 'companyName',
        name: 'Company',
        maxLengthOnMobile: 10,
      },
      {
        columnId: 'systemName',
        name: 'System Name',
      },
      {
        columnId: 'day',
        name: 'day',
      },
      {
        columnId: 'qty',
        name: 'Quantity',
      },{
        columnId: 'price',
        name: 'price',
      }
      ,{
        columnId: 'discountedPrice',
        name: 'discountedPrice',
      },{
        columnId: 'priceWithoutMVA',
        name: 'priceWithoutMVA',
      }

    ]

  
    this.sortingArray = ['Product Name', 'Product #', 'System Name', 'Quantity', 'Str. Qty.', 'Date', 'OrderId']

    // this.values$ = this.saleService.getSalesReport(params)
    this.values$  =  this.saleService.getSalesRecord()
    

    this.values$.subscribe(data=>{
      console.log(data)
      // this.columnSettings.forEach(column => this.columnTotals[column.columnId] = 0);

      // // Calculate totals
      // data.forEach(row => {
      //   this.columnSettings.forEach(column => {
      //     this.columnTotals[column.columnId] += row[column.columnId] ? Number(row[column.columnId]) : 0;  
      //   });
      // });
      // this.exportData = data;
    })
  }
  ngOnDestroy(): void {
    if (this.siteDataSub) this.siteDataSub.unsubscribe();
  }
  ngOnInit() {
  }

  displayedColumn() {
    return this.columnSettings.map(columnSetting => columnSetting.columnId);

  }


  calculateColumnTotals() {
    // Initialize totals
   
  }


  exportToExcel() {

    let fixedData: any[] = [];

    const columnNames = this.displayedColumns.map(c => c)
    const columnIds = this.displayedColumns.map(c => c)

    fixedData = this.exportData.map(_line => {
      let line = { ..._line };

      Object.keys(line).forEach((key) => {
        if (!columnIds.includes(key)) {
          delete line[key];
        }
        else {
          const tempValue = line[key];
          const i = columnIds.indexOf(key);
          if (columnNames[i] !== key) {
            line[columnNames[i]] = tempValue;
            delete line[key];
          }
        }
      })
      return line;
    })

    this.excelService.exportAsExcelFile(fixedData, moment().tz('Europe/Oslo').format('DD-MM-YYYY_HH:mm:ssZZ'));
  }

}
